import { Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { appStylesGuard, deskStylesGuard } from './core/guards/app-styles.guard';
import { adminGuard } from './admin/admin.guard';
import { deskFeatureGuard } from './desk/desk-feature.guard';
import { LandingLayoutComponent } from './landing/layout/landing-layout.component';
import { bookProjectResolver } from './pages/share/book-project-viewer/book-project.resolver';

export const appRoutes: Routes = [
  {
    path: 'account',
    component: LandingLayoutComponent,
    canActivate: [appStylesGuard],
    loadChildren: () => import('./account/account.routes').then(m => m.accountRoutes),
  },
  {
    path: 'book-project/:id',
    loadComponent: () => import('./pages/share/book-project-viewer/book-project-viewer.component').then(m => m.BookProjectViewerComponent),
    canActivate: [appStylesGuard],
    resolve: {
      bookProject: bookProjectResolver,
    },
    data: { title: 'Book Project' },
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./layouts/layout.component').then(m => m.LayoutComponent),
    loadChildren: () => import('./pages/pages.routes').then(m => m.pagesRoutes),
    canActivate: [AuthGuard, appStylesGuard],
  },
  {
    // Desk, the agentic writing mode: its own shell, without Bootstrap or the dashboard layout.
    path: 'desk',
    loadChildren: () => import('./desk/desk.routes').then(m => m.deskRoutes),
    canActivate: [AuthGuard, deskFeatureGuard, deskStylesGuard],
  },
  {
    // The admin dashboard, for administrators: its own light shell, like Desk, without Bootstrap.
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes),
    canActivate: [AuthGuard, adminGuard],
  },
  {
    path: 'pages',
    loadChildren: () => import('./extrapages/extrapages.routes').then(m => m.extrapagesRoutes),
    canActivate: [AuthGuard, appStylesGuard],
  },
  // The public pages, including the not-found page that catches every other URL.
  {
    path: '',
    component: LandingLayoutComponent,
    loadChildren: () => import('./landing/landing.routes').then(m => m.landingRoutes),
  },
];
